export const RESTOCK_REQUEST_STATUS_PENDING = 'PENDING'
export const RESTOCK_REQUEST_STATUS_CANCELLED = 'CANCELLED'
export const RESTOCK_REQUEST_STATUS_ITEM_RESTOCKED = 'ITEM_RESTOCKED'
export const RESTOCK_REQUEST_STATUS_ITEM_DISCONTINUED = 'ITEM_DISCONTINUED'
export const RESTOCK_REQUEST_STATUS_ITEM_RESTOCK_SCHEDULED = 'ITEM_RESTOCK_SCHEDULED'